import React from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { canManageTeam } from "@/lib/workspace";

// Leadership totals only — no names, leave types or individual attendance.
export function PeopleTodayCard({ d }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const canTeam = canManageTeam(user);
  const tiles = [
    ["in", "In today", d.in, "text-[#3D8B65]"],
    ["off", "Off today", d.off, d.off ? "text-[#4A78A8]" : "text-[#0B1729]"],
    ["part", "Part day", d.part, "text-[#0B1729]"],
    ["not_working", "Not working", d.non_working + d.holiday, "text-[#1E2D44]/55"],
    ...(d.leave_on ? [["pending_leave", "Leave to approve", d.pending_leave, d.pending_leave ? "text-[#B87F1E]" : "text-[#0B1729]"]] : []),
    ...(d.clocking_on ? [["clocked_in", "Clocked in now", d.clocked_in, "text-[#0B1729]"], ["pending_corrections", "Time corrections", d.pending_corrections, d.pending_corrections ? "text-[#B87F1E]" : "text-[#0B1729]"]] : []),
  ];
  return (
    <div className="amden-card p-6" data-testid="card-people-today">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <Icons.CalendarCheck size={17} className="text-[#FFB000]" strokeWidth={2} />
          <div>
            <h3 className="font-display text-base font-bold text-[#0B1729]">People today</h3>
            <p className="text-xs text-[#1E2D44]/50">{d.people} people with a work pattern · totals only</p>
          </div>
        </div>
        {canTeam && <button onClick={() => navigate("/team?tab=leave")} className="text-xs font-medium text-[#FFB000] hover:underline" data-testid="open-availability-link">Team availability</button>}
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-7">
        {tiles.map(([k, l, v, tone]) => (
          <div key={k} className="rounded-lg bg-[#F7F9FC] p-3" data-testid={`pt-${k}`}>
            <div className={`font-display text-xl font-bold ${tone}`}>{v}</div>
            <div className="text-[11px] text-[#1E2D44]/55">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
